import { Trash2 } from 'lucide-react';
import { LiksDropdown } from '../../components/liks/LiksDropdown/LiksDropdown';
import '../../components/liks/LiksMembersPanel/LiksMembersPanel.css';
import type {
  KnowledgeBaseGroupAssignment,
  KnowledgeMemberRole,
  WithResourceId,
} from '../../types/knowledge';

type RoleOption = {
  value: KnowledgeMemberRole;
  label: string;
};

type KnowledgeDatabaseGroupAssignmentRowProps = {
  assignment: WithResourceId<KnowledgeBaseGroupAssignment> & {
    userGroupId: string;
    role: KnowledgeMemberRole;
  };
  groupName: string;
  canManage: boolean;
  isPending: boolean;
  roleOptions: RoleOption[];
  memberRoles: KnowledgeMemberRole[];
  translate: (key: string, params?: Record<string, string>) => string;
  onRoleChange: (role: KnowledgeMemberRole) => void;
  onRequestRemove: () => void;
};

export function KnowledgeDatabaseGroupAssignmentRow({
  assignment,
  groupName,
  canManage,
  isPending,
  roleOptions,
  memberRoles,
  translate,
  onRoleChange,
  onRequestRemove,
}: KnowledgeDatabaseGroupAssignmentRowProps) {
  return (
    <li className="knowledge-group-assignments__row">
      <span className="knowledge-group-assignments__name">{groupName}</span>
      <div className="knowledge-group-assignments__actions">
        {canManage ? (
          <LiksDropdown
            className="knowledge-group-assignments__role liks-members__role-dropdown"
            variant="on-light"
            value={assignment.role}
            onChange={(value) => {
              const role = value as KnowledgeMemberRole;
              if (!memberRoles.includes(role) || role === assignment.role) {
                return;
              }
              onRoleChange(role);
            }}
            options={roleOptions}
            aria-label={translate('knowledge.members.groupRoleLabel', {
              name: groupName,
            })}
            disabled={isPending}
          />
        ) : (
          <span className="knowledge-group-assignments__badge">
            {translate(`knowledge.members.roles.${assignment.role}`)}
          </span>
        )}
        {canManage ? (
          <button
            type="button"
            className="liks-members__action liks-members__action--danger"
            disabled={isPending}
            onClick={onRequestRemove}
            aria-label={translate('knowledge.members.removeGroup', {
              name: groupName,
            })}
          >
            <Trash2 strokeWidth={2} aria-hidden />
            <span>{translate('knowledge.members.removeLabel')}</span>
          </button>
        ) : null}
      </div>
    </li>
  );
}
